var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"page-content apiPage"},[_c('h3',{staticClass:"text-center"},[_vm._v("API")]),_c('p',{staticClass:"text-center"},[_vm._v("Will be updating soon!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }